import { React, useState } from 'react';
import AnchorAdv from '../../../UI/AnchorAdv.js';

const SNR_BNFTS_V1Footer = () => {
  const [showPrivacy, setShowPrivacy] = useState('hide');
  const [showCookie, setShowCookie] = useState('hide');
  const modalClick = (clickValue) => {
    var modalAction = clickValue;
    switch (modalAction) {
      case 'showPrivacy': {
        setShowPrivacy('show');
        break;
      }
      case 'exitPrivacy': {
        setShowPrivacy('hide');
        break;
      }
      case 'showCookie': {
        setShowCookie('show');
        break;
      }
      case 'exitCookie': {
        setShowCookie('hide');
        break;
      }
    }
  };
  return (
    <>
      <footer className="container mt-5 pt-4 pb-3 border-top">
        <div
          className="footer-disclaimer text-center text-muted"
          style={{ fontSize: '0.75rem' }}
        >
          <p className="mb-2">
            <strong className="text-uppercase">Disclaimer:</strong> The material
            on this website is intended only to provide a summary and general
            overview on matters of interest.
          </p>
          <p>
            We do not charge a fee for this service, but we do receive a
            commission directly from our partners following successful
            introductions from this website. Any information we provide is for
            the purposes of illustrating the products promoted on this site only
            and should not be read as financial advice.
          </p>
        </div>
        <div
          className="footer-bottom text-center text-muted mt-4"
          style={{ fontSize: '0.85rem' }}
        >
          <p className="mb-1">
            Copyright © Saavy Finances. 2025 All Rights Reserved
          </p>
          <p className="mb-2">
            <AnchorAdv
              dataId=""
              className="text-muted text-decoration-none"
            ></AnchorAdv>
          </p>
          <p className="mb-0">
            <a
              style={{ cursor: 'pointer' }}
              data-bs-toggle="modal"
              data-bs-target="#privacyPolicyModal"
              className="text-muted text-decoration-none"
              onClick={() => modalClick('showPrivacy')}
            >
              Privacy Policy
            </a>
            <span className="mx-2">|</span>
            <a
              style={{ cursor: 'pointer' }}
              data-bs-toggle="modal"
              data-bs-target="#cookiePolicyModal"
              className="text-muted text-decoration-none"
              onClick={() => modalClick('showCookie')}
            >
              Cookies
            </a>
          </p>
        </div>
      </footer>

      <div
        className={`modal popup-modal ${showPrivacy}`}
        id="privacyPolicyModal"
        tabIndex={-1}
        aria-labelledby="privacyPolicyModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="privacyPolicyModalLabel">
                Privacy Policy
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => modalClick('exitPrivacy')}
              />
            </div>
            <div className="modal-body">
              <p>
                {' '}
                This Privacy Policy applies to Saavy Finances, We are committed
                to protecting and respecting your privacy and security. Whenever
                you provide us with your personal information not limited to
                your name, phone number, email address, birthdate, and other
                information, via our website “Site(s)”, we will treat that
                information in accordance with this policy and our terms and
                conditions. We may collect certain information via third-party
                analytics services, which may collect your non-sensitive user
                information. This may include: the information you provide us,
                your session ID, your user ID, and conversion data. This
                information provides us with tools to calculate the numbers and
                frequency of visitors on the Site and to understand how you and
                other users use the Site so as to improve your experience. By
                using the Site and any services we offer via our Site, you are
                agreeing to be bound by this policy. This policy may change from
                time to time, so please check this page periodically.{' '}
              </p>
              <p>
                We use the information that we collect to provide our services
                and help you find insurance, to contact you regarding other
                products and services in which we hope you will be interested,
                and to improve our site. We also use this information—directly,
                indirectly, and in combination with data we exchange with other
                parties—to introduce you to informational, service, and product
                offerings of Saavy Finances, its subsidiaries, affiliated
                companies, partners, and brands that are owned by, licensed by,
                or partnering with Saavy Finances (collectively, “Our
                Companies”) We do this by transferring, licensing, and sharing
                your personal information with Our Companies and hope you will
                be interested in the marketing materials and promotions with
                which you are presented. Our Companies also transfer, and share
                your personal information with affiliate marketers, and
                companies that want to advertise other products and services.
                Once a third-party obtains your personal information, its
                subsequent use is controlled by their business practices, which
                is beyond our control.{' '}
              </p>
              <p>
                <strong>Other Data Sharing:</strong>
              </p>
              <p>
                {' '}
                In addition, we may share information that we collect with our
                vendors or service providers who help us operate our business;
                in response to a subpoena or similar investigative demand, a
                court order, or a request for cooperation from a law enforcement
                or other government agency; to establish or exercise our legal
                rights; to defend against legal claims; when we believe
                disclosure is necessary to investigate, prevent, or take action
                regarding illegal activity, suspected fraud or other wrongdoing;
                to protect and defend the rights, property, or safety of our
                company, our employees, our web site users, or others; or to
                enforce our website terms and conditions or other agreements or
                policies. We may also transfer any data we collect in connection
                with a corporate change such as a merger, our acquisition by
                another company, or a partial or total sale of our assets
                (including as part of a bankruptcy proceeding).{' '}
              </p>
              <p>
                <strong>Linking</strong>
              </p>
              <p>
                {' '}
                We may link to other websites which are not within our control.
                Once you have left our website, we cannot be responsible for the
                protection and privacy of any information which you provide. You
                should exercise caution and look at the privacy statement
                applicable to the website in question.{' '}
              </p>
              <p>
                <strong>Data Protection</strong>
              </p>
              <p>
                {' '}
                You have a choice about whether you want to receive information
                from us. We will not use your personal information for marketing
                purposes if you have indicated that you do not wish to be
                contacted. You can change your marketing preferences at any time
                by contacting us by email:{' '}
                <a href="javascript:;">info@savvyfinances.co.uk</a>
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => modalClick('exitPrivacy')}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>

      <div
        className={`modal popup-modal ${showCookie}`}
        id="cookiePolicyModal"
        tabIndex={-1}
        aria-labelledby="cookiePolicyModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-scrollable">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="cookiePolicyModalLabel">
                Cookie Policy
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => modalClick('exitCookie')}
              />
            </div>
            <div className="modal-body">
              <h5> COOKIE POLICY </h5>
              <p>
                This website uses cookies to better the users experience while
                visiting the website. Where applicable this website uses a
                cookie control system allowing the user on their first visit to
                the website to allow or disallow the use of cookies on their
                computer / device. This complies with recent legislation
                requirements for website’s to obtain explicit consent from users
                before leaving behind or reading files such as cookies on a
                users computer / device.
              </p>
              <p>
                Cookies are small files saved to the users computers hard drive
                that track, save and store information about the users
                interactions and usage of the website. This allows the website,
                through it’s server to provide the users with a tailored
                experience within this website.
              </p>
              <p>
                Users are advised that if they wish to deny the use and saving
                of cookies from this website on to their computers hard drive
                they should take necessary steps within their web browsers
                security settings to block all cookies from this website and
                it’s external serving vendors.
              </p>
              <p>
                This website uses tracking software to monitor it’s visitors to
                better understand how they use it. This software is provided by
                Google Analytics which uses cookies to track visitor usage. The
                software will save a cookie to your computers hard drive in
                order to track and monitor your engagement and usage of the
                website but will not store, save or collect personal
                information. You can read Google’s privacy policy here for
                further information [http://www.google.com/privacy.html].
              </p>
              <p>
                Other cookies may be stored to your computers hard drive by
                external vendors when this website uses referral programs,
                sponsored links or adverts. Such cookies are used for conversion
                and referral tracking and typically expire after 30 days, though
                some may take longer. No personal information is stored, saved
                or collected.
              </p>
              <h5> HOW WE USE COOKIES</h5>
              <p>
                A cookie is a small file which asks permission to be placed on
                your computer’s hard drive. Once you agree, the file is added
                and the cookie helps analyse web traffic or lets you know when
                you visit a particular site. Cookies allow web applications to
                respond to you as an individual. The web application can tailor
                its operations to your needs, likes and dislikes by gathering
                and remembering information about your preferences.
              </p>
              <p>
                We use traffic log cookies to identify which pages are being
                used. This helps us analyse data about web page traffic and
                improve our website in order to tailor it to customer needs. We
                only use this information for statistical analysis purposes and
                then the data is removed from the system.
              </p>
              <p>
                Overall, cookies help us provide you with a better website, by
                enabling us to monitor which pages you find useful and which you
                do not. A cookie in no way gives us access to your computer or
                any information about you, other than the data you choose to
                share with us.{' '}
              </p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
                onClick={() => modalClick('exitCookie')}
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default SNR_BNFTS_V1Footer;
